<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { isMediaPreviewOpen, closeMediaPreview } from '@/composables/memorize/memorize'
import {
  isCommenDialogOpen,
  closeScheduleSetting,
  onScheduleSettingDone,
  isScheduleActionDialogOpen,
  closeScheduleAction
} from '@/composables/schedule/schedule'
import ModelDialog from '@/components/base/dialog/ModelDialog.vue'
const PreviewModelDialog = defineAsyncComponent(() => import('@/components/business/modal/PreviewModelDialog.vue'))
import { showMArticleTemplateDialog } from '@/composables/memorize/memorize'
import { showShareViaWechat } from '@/composables/wechat/wechat'
import { showGiftPlay, gifts2Play } from '@/composables/memorize/gift'
import { globalShowThanksExceed, globalShowZyDialog } from '@/composables/member/member'
const FestivalDialog = defineAsyncComponent(() => import('@/components/business/promotion/FestivalDialog.vue'))
const LifeScheduleSettingDialog = defineAsyncComponent(
  () => import('@/components/business/modal/LifeScheduleSettingDialog.vue')
)
const ScheduleActionDialog = defineAsyncComponent(() => import('@/components/business/modal/ScheduleActionDialog.vue'))
const MArticleTemplateDialog = defineAsyncComponent(
  () => import('@/components/business/modal/MArticleTemplateDialog.vue')
)
const ShareViaWechat = defineAsyncComponent(() => import('@/components/business/modal/ShareViaWechat.vue'))
const GiftPlay = defineAsyncComponent(() => import('@/components/business/memorize/gift/GiftPlay.vue'))
const ThanksForExceedMaxPeriod = defineAsyncComponent(
  () => import('@/components/business/modal/ThanksForExceedMaxPeriod.vue')
)
const MemorialPrivilegeDialog = defineAsyncComponent(
  () => import('@/components/business/memorize/cooperate/MemorialPrivilegeDialog.vue')
)
import { currentUser } from '@/composables/user/users'
import {
  globalShowMemorialPrivilegeDialog,
  globalName,
  globalAvatarUrl,
  globalInviteButtonRef,
  globalServiceId,
  globalYearPeriod,
  globalOnClose
} from '@/composables/memorize/memorize'
</script>
<template>
  <ModelDialog
    :model-value="isMediaPreviewOpen"
    :halfTrans="false"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none
    @update:model-value="closeMediaPreview">
    <PreviewModelDialog v-if="isMediaPreviewOpen" @close="closeMediaPreview()" />
  </ModelDialog>
  <ModelDialog
    :model-value="isCommenDialogOpen"
    :halfTrans="false"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none
    @update:model-value="closeScheduleSetting">
    <LifeScheduleSettingDialog v-if="isCommenDialogOpen" @close="closeScheduleSetting" @done="onScheduleSettingDone" />
  </ModelDialog>
  <ModelDialog
    :model-value="isScheduleActionDialogOpen"
    :halfTrans="false"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none
    @update:model-value="closeScheduleSetting">
    <ScheduleActionDialog v-if="isScheduleActionDialogOpen" @close="closeScheduleAction" />
  </ModelDialog>
  <!-- <ModelDialog :model-value="showMemorizeThemeDialog" :halfTrans="false" h-full max-h-full max-w-full w-full border-0 bg-transparent shadow-none>
    <MemorizeThemeSelectDialog v-if="showMemorizeThemeDialog"/>
  </ModelDialog> -->
  <ModelDialog
    :model-value="showMArticleTemplateDialog"
    :halfTrans="false"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none>
    <MArticleTemplateDialog v-if="showMArticleTemplateDialog" />
  </ModelDialog>
  <ModelDialog
    :z-index="3001"
    :model-value="showShareViaWechat"
    :halfTrans="false"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none>
    <ShareViaWechat />
  </ModelDialog>
  <ModelDialog
    :z-index="50"
    :model-value="showGiftPlay"
    :slow="true"
    :halfTrans="true"
    class="no-scrollbar"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none>
    <GiftPlay :gifts="gifts2Play" :anim="gifts2Play[0].anim as any" />
  </ModelDialog>
  <ModelDialog
    :z-index="3002"
    :model-value="globalShowThanksExceed"
    :slow="false"
    :halfTrans="false"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none>
    <ThanksForExceedMaxPeriod></ThanksForExceedMaxPeriod>
  </ModelDialog>
  <ModelDialog
    :z-index="10000"
    :model-value="globalShowZyDialog"
    :slow="false"
    :halfTrans="true"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none>
    <FestivalDialog></FestivalDialog>
  </ModelDialog>
  <ModelDialog
    :z-index="50"
    :model-value="globalShowMemorialPrivilegeDialog"
    :slow="false"
    :halfTrans="true"
    h-full
    max-h-full
    max-w-full
    w-full
    border-0
    bg-transparent
    shadow-none>
    <MemorialPrivilegeDialog
      :name="globalName || $t('alt.name')"
      v-if="globalInviteButtonRef"
      :serviceId="globalServiceId"
      :yearPeriod="globalYearPeriod"
      :avatarUrl="globalAvatarUrl || ''"
      @close="globalOnClose()" />
  </ModelDialog>
  <!-- <ModelDialog :z-index="9999" :model-value="state.realName.visible" :slow="false" :halfTrans="true" h-full max-h-full
    max-w-full w-full border-0 bg-transparent shadow-none>
    <SetRealNameDialog />
  </ModelDialog> -->
</template>
<style lang="scss" scoped>
.no-scrollbar {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}
</style>
